import React, {forwardRef, MutableRefObject, useEffect, useState} from "react";
import { Input } from "@rebass/forms";
import {FieldHelperProps, FieldInputProps, FieldMetaProps, useField} from "formik";
import {InputHelper, InputHelperOptionalParameters} from "./InputHelper";
import {Moment} from "moment";
import styled from "styled-components";

export const TextInput: React.FC<{
  name: string;
  errorText?: string;
  helperParameters?: InputHelperOptionalParameters;
  allowEmpty?: boolean;
}> = ({name, errorText, helperParameters= {label: name}, allowEmpty=false}) => {
  const validate = (value) => {
    if (value === "" && !allowEmpty) {
      return errorText || "Select a value";
    }
  };

  const [field, meta, helpers] = useField({ name, validate });

  return (
    <InputHelper meta={meta} helpers={helpers} {...helperParameters}>
      <TextBox value={meta.value} setValue={helpers.setValue}/>
    </InputHelper>
  );
};


export const TextBox = forwardRef(
  (
    {value, setValue, onBlur}: {
      value: string;
      setValue: (string) => void;
      onBlur?: (FocusEvent) => void;
      },
    ref
  ) => {
    const placeholder = "Type here..."
    const width = (2 + Math.max(value?.length || 0, placeholder.length)) * 9

    return (
      <StyledInputBox
        width={width}
        onBlur={(e) => {if (onBlur) onBlur(e)}}
        onChange={(e) => {
          setValue(e.target.value)
        }}
        onKeyDown={(e) => { // @ts-ignore
          if (e.code === "Enter") e.target.blur()
        }}
        value={value /* @ts-ignore */}
        placeholder={placeholder}
      />
    )
  }
)

export const StyledInputBox = styled.input<{width: number}>`
  width: ${props => props.width}px;
  display: inline;
  border: 0;
  border-bottom: 2px solid #dddddf;
  font-size: 16px;
  &:focus {
    outline: 0;
  }
`
